import React, { createContext, useContext, useReducer } from 'react'

/**
 * @typedef {{ isLogin?: boolean; token?: string; user?: object }} AppState
 * @typedef {{ type: 'LOGIN' | 'LOGOUT'; payload?: any; callback?: Function }} AppAction
 * @typedef {{ state: AppState; dispatch: (action: AppAction) => void }} AppStore
 */

/** @type {React.Context<AppStore>} */
const AppContext = createContext()

const GlobalStore = props => {
  if (props === undefined) {
    throw new Error(
      'Props Undefined. You probably mixed up betweenn default/named import'
    )
  }
  const { load, ...rest } = props
  const [state, dispatch] = useReducer(load.reducer, load.initialState)

  const _dispatch = (action) => {
    const { callback, ...rest } = action
    dispatch(rest)
    if (callback) callback()
  }

  return <AppContext.Provider value={{ state, dispatch: _dispatch }} {...rest} />
}

export const useStore = () => useContext(AppContext)

export default GlobalStore
